export default {
    "enemies": [
        { 
            "SpriteSheet": "bullet",
            "width": 140,
            "height": 128,
            "sprites": [
                {
                    "name": "bulletLeft",
                    "x": 7,
                    "y": 1162
                }
            ]
        },
        {
            "SpriteSheet": "dragonHalfFlattened",
            "width": 43,
            "height": 34,
            "sprites": [
                {
                    "name": "halfFlattenedWalkLeft1",
                    "x": 169,
                    "y": 325
                },
                {
                    "name": "halfFlattenedWalkLeft2",
                    "x": 130,
                    "y": 325
                },
                {
                    "name": "halfFlattenedWalkRight1",
                    "type": "flip",
                    "x": 169,
                    "y": 325
                },
                {
                    "name": "halfFlattenedWalkRight2",
                    "type": "flip",
                    "x": 130,
                    "y": 325
                },
            ]
        },
        {
            "SpriteSheet": "dragonFlattened",
            "width": 43,
            "height": 20,
            "sprites": [
                {
                    "name": "flattenedLeft",
                    "x": 89,
                    "y": 328
                },
                {
                    "name": "flattenedRight",
                    "type": "flip",
                    "x": 89,
                    "y": 328
                },
            ]
        },
        {
            "SpriteSheet": "dragonRegular",
            "width": 43,
            "height": 63,
            "sprites": [
                {
                    "name": "regularWalkLeft1",
                    "x": 249,
                    "y": 318
                },
                {
                    "name": "regularWalkLeft2",
                    "x": 209,
                    "y": 318
                },
                {
                    "name": "regularWalkRight1",
                    "type": "flip",
                    "x": 209,
                    "y": 318
                },
                {
                    "name": "regularWalkRight2",
                    "type": "flip",
                    "x": 249,
                    "y": 318
                },
            ]
        },
        {
            "SpriteSheet": "koopa",
            "width": 35,
            "height": 50,
            "sprites": [
                {
                    "name": "walkLeft1",
                    "x": 291,
                    "y": 0
                },
                {
                    "name": "walkLeft2",
                    "x": 251,
                    "y": 0
                },
                {
                    "name": "walkRight1",
                    "type": "flip",
                    "x": 291,
                    "y": 0
                },
                {
                    "name": "walkRight2",
                    "type": "flip",
                    "x": 251,
                    "y": 0
                },
            ]
        },
        {
            "SpriteSheet": "koopaShell",
            "width": 35,
            "height": 35,
            "sprites": [
                {
                    "name": "shell1",
                    "type": "flip",
                    "x": 171,
                    "y": 5
                },
                {
                    "name": "shell2",
                    "type": "flip",
                    "x": 171,
                    "y": 45
                },
                {
                    "name": "shell3",
                    "type": "flip",
                    "x": 171,
                    "y": 85
                },
            ]
        }
    ]
}